import { Event, Identifiable } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditRequest(
  event: Identifiable<Event>,
  { nextEvent, event: e }: Boundaries["editEvent"]["request"],
): Identifiable<Event> {
  return e.uuid === event.uuid ? { ...event, ...nextEvent } : event;
}

function handleEditSuccess(
  event: Identifiable<Event>,
  nextEvent: Boundaries["editEvent"]["success"],
): Identifiable<Event> {
  return nextEvent.uuid === event.uuid ? { ...event, ...nextEvent } : event;
}

function handleEditFailure(
  event: Identifiable<Event>,
  { event: e }: Boundaries["editEvent"]["failure"],
): Identifiable<Event> {
  return e.uuid === event.uuid ? e : event;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
